






























































import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/bucket/favorite/CClassifiedFavoriteButton.vue'
import CClassifiedThumbnail from '~/components/shared/configurable/classified/image/CClassifiedThumbnail.vue'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CClassifiedThumbnail,
    CClassifiedFavoriteButton
  },
  props: {
    data: { type: Object, required: true },
    target: { type: String, default: '_self' },
    parkingButton: { type: Boolean, default: true },
    selected: { type: Boolean, default: true },
    showLink: { type: Boolean, required: false, default: true },
    currentUser: { type: Object, default: () => null }
  },
  computed: {
    url() {
      return this.data.seo_url || `/${this.data.id}`
    },
    title() {
      return this.data.title
    },
    address() {
      return this.data.address
    },
    isItemDisabled() {
      if (this.data.states?.isDeleted || this.data.states?.isRemoved) {
        return true
      }

      return false
    }
  },
  methods: {
    mainLinkClicked(e) {
      e.preventDefault()
      e.stopPropagation()
      return false
    },
    handleParking({
      e,
      classifiedId,
      isParked
    }: {
      e: Event
      classifiedId: number
      isParked: boolean
    }) {
      e.stopPropagation()
      e.preventDefault()
      if (isParked) {
        this.$refs.parkingButton.park()
      } else {
        this.$refs.parkingButton.unpark()
      }
      this.$emit('park', { classifiedId, isParked })
    },
    handleInfoClick(e: Event) {
      if (this.showLink) {
        this.$refs.thumb.imgClicked(e)
      }
    },
    classifiedClicked(evt, refData) {
      // remove this hack when https://github.com/vuejs/vue-router/issues/703 is resolved

      this.$analytics.recordEvent({
        namespace: 'n_map_search_slider_classified_click',
        action: 'click',
        label: this.data.title + ' (' + this.data.id + ')'
      })

      if (evt) {
        evt.preventDefault()
        if (evt.ctrlKey) {
          window.open(this.dataURL)
          return
        }
      }
      const refs = {
        categoryIds: refData.categoryIds || this.data.categoryIds,
        id: refData.id || this.data.id,
        isParked: refData.isParked || this.currentUser?.isParked,
        thumb: refData.thumb || this.data.data?.photos?.native?.covers?.a,
        title: refData.title || this.data.title,
        price: refData.price || this.data.price?.value,
        salary: refData.salary || this.data.salary,
        payment: refData.payment || this.data.payment,
        thumbIndex: refData.thumbIndex || 0,
        offertype: refData.offertype || this.data.offertype,
        hasPhotos: refData.hasPhotos || this.data.hasPhotos,
        thumbsLength: refData.thumbsLength || (this.data.hasPhotos ? 1 : 0),
        externalLink: refData.externalLink || this.data.externaLink || null
      }

      this.$store.commit('classifieds/view/SET_REFS', refs)

      return this.$router.push({
        path: this.url
      })
    }
  }
})
